import classNames from 'classnames';
import { useId } from 'react';

import { paths } from '@farmersdog/constants';
import { Card, Link, ResponsiveText } from '@farmersdog/corgi';
import { GridContainer } from '@farmersdog/corgi-x';

import styles from './BuildYourPlanCard.css';
import { PlanStep } from './PlanStep';
import { planStepData } from './planStepData';

export interface BuildYourPlanCardProps {
  breed: string;
  className?: string;
}

export function BuildYourPlanCard({
  breed,
  className,
}: BuildYourPlanCardProps) {
  const id = useId();

  return (
    <Card aria-labelledby={id} className={classNames(styles.card, className)}>
      <ResponsiveText
        className={styles.title}
        id={id}
        variant="heading-2"
        as="h2"
        color="kale-3"
      >
        Build a plan for your {breed}
      </ResponsiveText>
      <ResponsiveText
        className={styles.description}
        variant="article-1"
        as="p"
        color="charcoal-3"
      >
        Your {breed} will do best on a diet of nutrient-dense food made from
        fresh, whole ingredients.
      </ResponsiveText>
      <GridContainer as="ul" aria-labelledby={id} className={styles.grid}>
        {planStepData.map(planStep => {
          return <PlanStep key={planStep.step} {...planStep} />;
        })}
      </GridContainer>
      <Link
        className={styles.cta}
        variant="primary"
        href={paths.PATH_SIGNUP}
        asButton
      >
        Build Your Plan
      </Link>
    </Card>
  );
}
